import React from 'react';

export const CierreStatusBadge: React.FC<{
  status: 'abierto' | 'cerrado';
  lockedAt?: string | null;
}> = ({ status, lockedAt }) => {
  if (status === 'cerrado') {
    const t = lockedAt
      ? new Date(lockedAt).toLocaleString('es-CO', { timeZone: 'America/Bogota' })
      : '';
    return (
      <span className="inline-flex items-center rounded-full bg-emerald-100 px-3 py-1 text-xs font-semibold text-emerald-800">
        Cerrado{t ? ` · ${t}` : ''}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold text-amber-900">
      Abierto
    </span>
  );
};
